module.exports = __webpack_public_path__ + "assets/img/thumb-Cluey-Learning-1-Landing-Page-+-Website.76c91e68.jpg";